import { FormInput } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change, Field } from 'redux-form'
import { Divider, Form, Header } from 'semantic-ui-react'
import { validateLength160, validateRequired } from '../../../shared/Forms/ReduxForm'

const mapStateToProps = (state, ownProps) => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      change,
    },
    dispatch
  )
}

class ProductCoreData extends React.Component {
  render() {
    // state
    const { product = {}, compareProduct } = this.props

    const both = !!(product && compareProduct)
    const titleDeChanged = both && product.wd_title !== compareProduct.wd_title
    const titleFrChanged =
      both && product.wd_title2 !== compareProduct.wd_title2
    const priceChanged = both && product.wd_price !== compareProduct.wd_price
    const discountClassChanged =
      both && product.wd_discount_class !== compareProduct.wd_discount_class
    const weightChanged = both && product.wd_weight !== compareProduct.wd_weight
    const unitChanged = both && product.wd_unit !== compareProduct.wd_unit
    const plugChanged = both && product.wd_plug !== compareProduct.wd_plug
    //const extra2Changed = both && product.wd_extra2 !== compareProduct.wd_extra2
    const extra3Changed = both && product.wd_extra3 !== compareProduct.wd_extra3

    return (
      <div className="ProductCoreData">
        <Header as="h3" dividing>
          Produkttitel
        </Header>
        <Form.Group widths="equal">
          <Field
            component={FormInput}
            name="title_de"
            fluid
            icon="flag"
            placeholder={I18n.t('navigation.languages.de')}
            className={titleDeChanged ? 'original' : ''}
            label={I18n.t('admin.product.core_data.title_de')}
            validate={validateRequired}
          />
          <Field
            component={FormInput}
            name="title_fr"
            fluid
            icon="flag outline"
            placeholder={I18n.t('navigation.languages.fr')}
            className={titleFrChanged ? 'original' : ''}
            label={I18n.t('admin.product.core_data.title_fr')}
            validate={validateRequired}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Field
            component={FormInput}
            name="seo_description_de"
            fluid
            icon="flag"
            placeholder={I18n.t('navigation.languages.de')}
            className={titleDeChanged ? 'original' : ''}
            label={I18n.t('admin.product.core_data.seo_de')}
            validate={validateLength160}
          />
          <Field
            component={FormInput}
            name="seo_description_fr"
            fluid
            icon="flag outline"
            placeholder={I18n.t('navigation.languages.fr')}
            className={titleFrChanged ? 'original' : ''}
            label={I18n.t('admin.product.core_data.seo_fr')}
            validate={validateLength160}
          />
        </Form.Group>

        {['product', 'import'].includes(product.kind) && (
          <div>
            <Header as="h3" dividing>
              Stammdaten WinDelta
            </Header>

            <Form.Input
              name="wd_title"
              readOnly
              value={
                titleDeChanged ? compareProduct.wd_title : product.wd_title
              }
              fluid
              icon="flag"
              placeholder={I18n.t('navigation.languages.de')}
              className={titleDeChanged ? 'changed' : ''}
              label={I18n.t('admin.product.core_data.wd_title_de')}
            />
            <Form.Input
              name="wd_title2"
              readOnly
              value={
                titleFrChanged ? compareProduct.wd_title2 : product.wd_title2
              }
              fluid
              icon="flag outline"
              placeholder={I18n.t('navigation.languages.fr')}
              className={titleFrChanged ? 'changed' : ''}
              label={I18n.t('admin.product.core_data.wd_title_fr')}
            />
            <Form.Group widths="equal">
              <Form.Input
                readOnly
                fluid
                label="Rabattklasse"
                name="discountClass"
                className={discountClassChanged ? 'changed' : ''}
                value={
                  discountClassChanged
                    ? compareProduct.wd_discount_class
                    : product.wd_discount_class
                }
              />
              <Form.Input
                readOnly
                fluid
                label="Gewicht netto"
                name="netWeight"
                className={weightChanged ? 'changed' : ''}
                value={
                  weightChanged ? compareProduct.wd_weight : product.wd_weight
                }
              />
              <Form.Input
                readOnly
                fluid
                label="ME"
                name="units"
                className={unitChanged ? 'changed' : ''}
                value={unitChanged ? compareProduct.wd_unit : product.wd_unit}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                readOnly
                fluid
                label="Steckertyp"
                name="plug"
                className={plugChanged ? 'changed' : ''}
                value={plugChanged ? compareProduct.wd_plug : product.wd_plug}
              />
              <Form.Input
                readOnly
                fluid
                label="Versandart"
                name="extra3"
                className={extra3Changed ? 'changed' : ''}
                value={
                  extra3Changed ? compareProduct.wd_extra3 : product.wd_extra3
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                readOnly
                fluid
                label="Preis (netto, exkl. MwSt.)"
                name="netPriceCHF"
                className={priceChanged ? 'changed' : ''}
                value={
                  priceChanged ? compareProduct.wd_price : product.wd_price
                }
              />
              <Form.Input
                readOnly
                label={`Lagerbestand, aktualisiert: ${new Date(
                  product.stock_updated_at
                ).toLocaleDateString('de-CH', config.format.date)}`}
                name="stockUpdated"
                value={product.stock}
              />
            </Form.Group>
          </div>
        )}
        <Divider hidden />
      </div>
    )
  }
}

ProductCoreData = connect(mapStateToProps, mapDispatchToProps)(ProductCoreData)
export default ProductCoreData



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductCoreData.jsx